import { USER_ROLES, USER_ROLES_MAP } from "./constant";

/**
 * Default user roles for company create (Reseller or End User company type).
 * Keep in sync with company-default-user-helper.js.
 */
export const DEFAULT_USER_ROLE_CHOICES = [
  USER_ROLES.RESELLER,
  USER_ROLES.COMPANY_ADMIN,
];

function labelForRole(role) {
  return USER_ROLES_MAP[role] || role;
}

/**
 * Roles the logged-in user may assign when creating a default user on a new company.
 * Intersects user-create rules with Reseller / Company user only (no Sub-Superadmin).
 */
function creatableDefaultUserRoles({
  isSuperAdmin,
  isCompanyAdmin,
  creatorAssignedIsOwnCompany,
  isReseller,
  loggedUserParent,
  loggedUserSuperParent,
  loggedUserSuperSuperParent,
}) {
  const roles = [];

  if (isSuperAdmin) {
    roles.push(USER_ROLES.RESELLER, USER_ROLES.COMPANY_ADMIN);
    return roles;
  }

  if (isCompanyAdmin && !creatorAssignedIsOwnCompany) {
    roles.push(USER_ROLES.COMPANY_ADMIN);
  }

  if (isReseller && !creatorAssignedIsOwnCompany) {
    if (
      loggedUserParent === USER_ROLES.RESELLER &&
      loggedUserSuperParent === USER_ROLES.RESELLER &&
      loggedUserSuperSuperParent === USER_ROLES.RESELLER
    ) {
      roles.push(USER_ROLES.COMPANY_ADMIN);
    } else {
      roles.push(USER_ROLES.RESELLER, USER_ROLES.COMPANY_ADMIN);
    }
  }

  return roles;
}

/**
 * Role dropdown for default user on company create — Reseller or Company user only,
 * for both Reseller company and End User company types.
 */
export function getDefaultUserRolesForCompanyCreate({
  isSuperAdmin,
  isCompanyAdmin,
  creatorAssignedIsOwnCompany,
  isCallCenterAdmin,
  isReseller,
  loggedUserParent,
  loggedUserSuperParent,
  loggedUserSuperSuperParent,
  isCreatingResellerCompany,
  isCreatingEndUserCompany,
}) {
  if (!isCreatingResellerCompany && !isCreatingEndUserCompany) {
    return [];
  }

  const creatable = creatableDefaultUserRoles({
    isSuperAdmin,
    isCompanyAdmin,
    creatorAssignedIsOwnCompany,
    isReseller,
    loggedUserParent,
    loggedUserSuperParent,
    loggedUserSuperSuperParent,
  });

  const allowed = new Set(DEFAULT_USER_ROLE_CHOICES);
  const seen = new Set();
  const out = [];

  for (const role of DEFAULT_USER_ROLE_CHOICES) {
    if (!allowed.has(role) || !creatable.includes(role) || seen.has(role)) continue;
    seen.add(role);
    out.push({ value: role, label: labelForRole(role) });
  }

  return out;
}
